import username from 'flarum/common/helpers/username';
import User from 'flarum/common/models/User';
import Group from 'flarum/common/models/Group';
import LinkButton from 'flarum/common/components/LinkButton';
import classList from 'flarum/common/utils/classList';
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class RecipientLabel extends Component {
  view(vnode) {
    const {
      recipient,
      link,
      ...newAttrs
    } = this.attrs;
    newAttrs.style = newAttrs.style || {};
    newAttrs.className = classList('RecipientLabel', newAttrs?.className);
    if (link && recipient instanceof User) {
      newAttrs.href = app.route.user(recipient);
    }
    let label;
    if (recipient instanceof User) {
      label = username(recipient);
      if (!newAttrs.href && recipient.id() !== app?.session?.user?.id()) {
        newAttrs.href = app.route.user(recipient);
      }
    } else if (recipient instanceof Group) {
      return m("span", {
        class: newAttrs.className
      }, recipient.namePlural());
    } else {
      newAttrs.className += ' none';
      label = app.translator.trans('core.lib.username.deleted_text');
    }
    return m(LinkButton, newAttrs, label);
  }
}
flarum.reg.add('fof-byobu', 'forum/pages/labels/RecipientLabel', RecipientLabel);